import { FAIcon } from "./faIcon";
import { Button } from "./button";
import { FullHeightContainer } from "./FullHeighContainer";
import { Helper } from "../util/helper";
import { NotificationHelper } from "../util/notificationHelper";
import { Config } from "../config/config";
import { httpService } from "../../statistics/services";
import { HTTPService, JsonResultClass } from "../util/httpManager";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Context } from "./commonApp";
import React from "react";
export default class ProcessDiagram extends React.Component<ProcessDiagramProps, any>{
    private _elementRef: any;
    private _ref: kendo.dataviz.ui.Diagram;
    private _data: any = null;
    private _dataUrl: string;
    private _canLoadData: boolean = true;
    private _refIcons = {};
    private _digramBuilded = false;

    constructor(props) {
        super(props)
        this._setDataURL();
    }

    private _setDataURL = () => {
        let id = this.props.handleEval(this.props.model);

        if (typeof id === "number")
            this._dataUrl = "ProcessDiagram/GetData?name=" + this.props.name + "&rootEntity=" + this.props.rootEntity + "&idAsInt=" + id;
        else
            this._dataUrl = "ProcessDiagram/GetData?name=" + this.props.name + "&rootEntity=" + this.props.rootEntity + "&idAsString=" + encodeURIComponent(id);
    }

    componentDidMount() {
        this._getData();

        const sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, eventInfo => {
            if (eventInfo != null && eventInfo.event === "Reloading") {
                this._digramBuilded = false;
                if (this._canLoadData)
                    this._getData();
                this._canLoadData = false;
            }
        })

    }
    componentWillReceiveProps(props) {
        var isSaveExists = Helper.hasValue(props.entity?.IsSaved);
        if (isSaveExists && props.entity.IsSaved) {
            this._digramBuilded = false;
            if (this._canLoadData)
                this._getData();
            this._canLoadData = false;
        }
    }
    private _buildDiagram = () => {
        var shapesDataSource = new kendo.data.DataSource({
            data: this._data.items,
        });
        var connectionsDataSource = new kendo.data.DataSource({
            data: this._data.connections,
        });

        this._ref = $(this._elementRef).kendoDiagram({
            dataSource: shapesDataSource,
            connectionsDataSource: connectionsDataSource,
            layout: {
                type: "tree",
                subtype: "down"
            },
            shapeDefaults: {
                visual: this._visualTemplate
            },
            connectionDefaults: {
                stroke: {
                    color: "#979797",
                    width: 2
                }
            },
            editable: false,
            click: this._handleClick,
            dataBound: function () {
                var bbox = this.boundingBox();
                this.wrapper.width(bbox.width + bbox.x + 50);
                this.wrapper.height(bbox.height + bbox.y + 50);
                this.resize();
            }
        }).data("kendoDiagram");

        this._digramBuilded = true;
        if (Helper.hasValue(this.props.entity?.IsSaved) && this.props.entity.IsSaved) {
            this._canLoadData = true;
            let copiedEntity: any = JSON.parse(JSON.stringify(this.props.entity));
            copiedEntity.IsSaved = false;
            Helper.updateEntity(this.props.entity, copiedEntity);

        }

    }

    private _handleClick = (e: kendo.dataviz.ui.DiagramClickEvent) => {
        let id = this.props.context.contextType + "_" + this.props.handleEval(this.props.model);

        if (Helper.hasValue(e.item.dataItem.url) && e.item.dataItem.id != id)
            Helper.openInNewBrowserTab(Config.baseUrl + e.item.dataItem.url);
    }

    private _visualTemplate = (options) => {
        var dataviz = kendo.dataviz;
        var g = new dataviz.diagram.Group();
        var dataItem = options.dataItem;

        let text = dataItem.text;
        let id = this.props.context.contextType + "_" + this.props.handleEval(this.props.model);

        let rect: any = new dataviz.diagram.Rect();
        rect.x = 45;
        rect.y = 10;
        rect.width = 0;
        rect.height = 0;
        let layout = new dataviz.diagram.Layout(rect);

        var texts = text === null ? "" : text.split("|");
        for (var i = 0; i < texts.length; i++) {
            layout.append(new dataviz.diagram.TextBlock({
                text: texts[i],
                fontSize: id === dataItem.id ? 20 : 15
            }));
        }
        layout.reflow();

        // Y Position des letzten Kindelements ermitteln um die notwendige Höhe des Shapes zu bestimmen
        var last = (layout as any).children[(layout as any).children.length - 1];
        var box = last.drawingElement.bbox();

        // Breitestes Element ermitteln um die notwendige Breite des Shapes zu ermitteln
        let widestBox = 0;
        for (var i = 0; i < (layout as any).children.length; i++) {
            let current = (layout as any).children[i];
            let box = current.drawingElement.bbox();
            if (box.size.width > widestBox)
                widestBox = box.size.width;
        }

        g.append(new dataviz.diagram.Rectangle({
            width: widestBox + 60,
            height: box.origin.y + 30,
            stroke: {
                width: 0
            },
            fill: {
                color: dataItem.shapeColor
            }
        }));

        // Streifen für Status rendern
        if (dataItem.status) {
            g.append(new dataviz.diagram.Rectangle({
                width: 8,
                height: box.origin.y + 30,
                stroke: {
                    width: 0
                },
                fill: {
                    color: dataItem.status.color
                }
            }));

            // Tooltip: Geht erst ab Kendo R2 2016!
            g.drawingElement.options.tooltip = {
                content: dataItem.status.text,
                shared: true
            };
        }

        if (dataItem.icon) {
            const fontAwesomeCode: string = this._refIcons[dataItem.icon];

            g.append(new dataviz.diagram.TextBlock({
                x: 15,
                y: 20,
                text: fontAwesomeCode.replace(/"/g, ''),
                fontSize: 20,
                fontFamily: "FontAwesome"
            }));
        }

        g.append(layout);

        return g;
    }

    private _getData = () => {
        HTTPService.get<JsonResultClass>(this._dataUrl)
            .then(result => {
                if (result.Code == 0) {
                    this._data = result.Data;
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }

                this.setState({}, () => {
                    if (!this._digramBuilded) {
                        this._buildDiagram();
                    }
                });
            });
    }

    private _exportAsPdf = () => {
        kendo.pdf.defineFont({
            "FontAwesome":
                Config.baseUrl + "Content/fontawesome/webfonts/fa-regular-400.ttf"
        });
        this._ref.exportPDF().done(function (data) {
            kendo.saveAs({
                dataURI: data,
                fileName: "ProcessDiagram.pdf"
            });
        });
    }

    private setRefIcon = (iconName: string, i: HTMLElement) => {
        if (i) {
            const fontAwesomeCode = window.getComputedStyle(i, "::before").content;
            this._refIcons[iconName] = fontAwesomeCode;
        }
    }

    private _renderIcons = () => {
        let icons: Array<string> = [];
        let iconDivs = [];
        if (this._data) {
            for (let item of this._data.items) {
                if (item.icon && icons.indexOf(item.icon) == -1)
                    icons.push(item.icon);
            }

            for (let icon of icons) {
                iconDivs.push(
                    <div key={icon}>
                        <i ref={(r) => { this.setRefIcon(icon, r) }} className={`fal fa-${icon}`} style={{ display: "none" }}></i>
                    </div>
                )
            }
        }
        return iconDivs;
    }

    render() {
        return (
            <div className="flex-container">
                {this._renderIcons()}
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                    <Button handleClick={this._exportAsPdf} iconName={"file-pdf"}></Button>
                </div>
                <FullHeightContainer style={{ overflowX: "auto" }}>
                    <div className="flex-container__item" ref={(r) => this._elementRef = r}>
                    </div>
                </FullHeightContainer>
            </div>
        );
    }
}

interface ProcessDiagramProps {
    context: Context;
    handleEval(action: string, prepare?: any);
    entity: any;
    name: string;
    rootEntity: string,
    model: string;
}